export default {
  name: 'facingtype-card-user-select',
  props: {
    target: {
      type: String,
      required: true,
      validator: val => ['get', 'give'].includes(val)
    }
  },
  data: () => ({
    shops: [],
    selectedShopId: null,
    users: []
  }),
  computed: {
    shopByShopId () {
      return this.shops.find(val => val.id === this.selectedShopId)
    },
    getUserImage () {
      return url => {
        if (url) return url + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
        return require('../images/icon_submenu_face.png')
      }
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      const d = new Date()
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const day = d.getDate()
      const hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      const min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      const sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  created: function () {
    this.getShops()
  },
  methods: {
    async getShops () {
      this.shops = []
      const res = await this.$store.dispatch('MYCARD_GET_SHOPS')
      // 表示しない店舗を取り除く
      this.shops = res.filter(shop => {
        if (shop.id !== 4 && shop.id !== 730 && shop.id !== 750 && shop.id !== 800) {
          return shop
        }
      })
      this.selectedShopId = window.localStorage.getItem('shop_id')
      await this.searchUsersByShopId()
    },
    async searchUsersByShopId () {
      this.users = []
      const params = {
        shop_id: Number(this.selectedShopId)
      }
      const res = await this.$store.dispatch('MYCARD_SEARCH_USERS_BY_SHOP_ID', params)
      if (res.hasOwnProperty('status')) {
        return
      }
      this.users = res
    },
    selectUser (userIndex) {
      const selectedUser = this.users[userIndex]
      this.$emit('select-user', { ...selectedUser })
      this.$emit('close-modal')
    },
    closeModal () {
      this.$emit('close-modal')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/facingtype-card-user-select.js